export default function getBgStyles(src, bgSize, bgPosition) {
    return {
        'background-image': 'url(' + src + ')',
        'background-repeat': 'no-repeat',
        'background-position': bgPosition ? bgPosition : 'center center',
        'background-size': bgSize ? bgSize : 'contain'
    }
}
